import {selector, selectorFamily } from "recoil";
import axios from "axios";
import { baseurl } from "./baseurl";
import { userDataState,bearerToken } from "../atoms/dashboard";
import { empSkill } from "./dashboard";
export const explrRols = selector({
    key: "explrRols1",
    get: async ({ get, set }) => {
        const usrid = get(userDataState);
        console.log('explrorlesz',usrid);
        const empskil=get(empSkill);
        console.log('explrorlesz',empskil);
        console.log('explrorlesz',empskil.fullData)
        let resDta= [];
        if(empskil.fullData.length>0){
        resDta= empskil?.fullData?.map((data)=>{
          return {"skillName":data.skills,"proficiencyId":data.proficiency_level,"proficiency":"medium","skillType":data.skill_type}
          })
          
        }
        console.log('explrorlesz',resDta);
      try {
        
        console.log(baseurl + "/api/employee/getempskillset")
        const bearToken = get(bearerToken);
        axios.defaults.headers.common['Authorization'] = bearToken;
        const getLat = await axios.post(baseurl + "/api/employee/getempskillset", {
                "empID": usrid.empID,
                "employeeSkillDetails":resDta
              
        });
        // const getLat = await axios.post(baseurl + "/api/employee/getempskillset", {
        //   "empID": "30178",
        //   "employeeSkillDetails": [
        //     {
        //       "skillName": "Adobe Photoshop",
        //       "proficiencyId": "4",
        //       "proficiency": "Advance Expert",
        //       "skillType": "Primary"
        //     },  {
        //       "skillName": "Adobe Illustrator",
        //       "proficiencyId": "3",
        //       "proficiency": "Medium",
        //       "skillType": "Primary"
        //     }
        
        //   ]
        // });
        let newar=[];
        const latData = await getLat?.data;
        
        console.log(latData.length);
        if(latData!='No record found' && latData.length < 4){
          let cntv=4-latData.length;
         
          console.log(cntv);

          for(var i=0;i<cntv;i++){
            console.log(i);
            let arrval={};
           newar.push(arrval);
          }
         console.log(newar);
         let retdataarr=latData.concat(newar);
         console.log(retdataarr);
         return retdataarr;
       } else if(latData=='No record found') {
        for(var i=0;i<4;i++){
          console.log(i);
          let arrval={};
         newar.push(arrval);
        }
        return newar;
       } else {
        return latData;
       }
      
        
      } catch (error) {
      
        console.log("error");
      }
    },
    set: () => {},
  });

  export const suggestedRols = selector({
    key: "suggestedRols1",
    get: async ({ get, set }) => {
        const usrid = get(userDataState);
        const sugroles=get(explrRols);
        console.log('explrorlesz',sugroles);
        let resDta= [];
        if(sugroles?.length>0){
        resDta= sugroles?.map((data)=>{
          return data.jdmMappingId
          })
          console.log('sug moves',resDta);
        }
      try {
        console.log(baseurl + "/api/employee/getempsuggestedmoves")
        const bearToken = get(bearerToken);
        axios.defaults.headers.common['Authorization'] = bearToken;
        const getLat = await axios.post(baseurl + "/api/employee/getempsuggestedmoves", {
          "employeeId": usrid.empID,
          "jdmMappingId": resDta.toString()
        });
        // const getLat = await axios.post(baseurl + "/api/employee/getempsuggestedmoves", {
        //   "employeeId": "30178",
        //   "jdmMappingId": "2638,2640"
        // });
        const latData = await getLat?.data;
        return latData;
      } catch (error) {
        console.log("error");
        return "No Record Found";
      }
    },
    set: () => {},
  });